class QuotationTimetableComponent {
    /** @ngInject */
    constructor(DeviceChecker) {
        this.isMobile = DeviceChecker.isMobile
    }

    $onChanges(changes) {
        if (changes.store) {
            this.sleek_timetable = changes.store.currentValue.timetableView.sleek_timetable
        }
    }

    close() {
        this.onDispatch({ $event: { type: 'GO_TO_STATE_RESULT', origin: 'TIMETABLE_BTN_UNDERSTOOD' } })
    }

    updateSleek() {
        this.onDispatch({ $event: { type: 'UPDATE_SLEEK_TIMETABLE', sleek_timetable: this.sleek_timetable } })
    }

    goToNextTutorialStep() {
        this.onDispatch({ $event: { type: 'TIMETABLE_VIEW_TUTORIAL_NEXT' } })
    }

    closeTutorial() {
        this.onDispatch({ $event: { type: 'TIMETABLE_VIEW_TUTORIAL_CLOSE' } })
    }
}

export default {
    template: require('./quotationTimetable.jade')(),
    controller: QuotationTimetableComponent,
    bindings: {
        store: '<',
        onDispatch: '&',
    },
}



// WEBPACK FOOTER //
// ./src/states/quotation/component/quotationTimetable.js